import Enums from "../../../enums/enums";
const state = {
  registerLoadingStatus: Enums.LoadingStatusType.None,
  getRegisterReponseType: null,
  getRegister: null,
  googleProfile: null,
  acceptInvitationLoadingStatus: Enums.LoadingStatusType.None,
  acceptInvitationModel: {},
  insertUserProfileConsentLoadingStatus: Enums.LoadingStatusType.None,
  getUserProfileConsentLoadingStatus: Enums.LoadingStatusType.None,
  registerModel: null,
  userprofileConsentModel: null,
};

const getters = {
  GetRegisterLoadingStatus: (state) => {
    return state.registerLoadingStatus;
  },
  GetRegister: (state) => {
    return state.getRegister;
  },
  GetGoogleProfile: (state) => {
    return state.googleProfile;
  },
  GetAcceptInvitationModel: (state) => {
    return state.acceptInvitationModel;
  },
  GetAcceptInvitationLoadingStatus: (state) => {
    return state.acceptInvitationLoadingStatus;
  },
  GetInsertUserProfileConsentLoadingStatus: (state) => {
    return state.insertUserProfileConsentLoadingStatus;
  },
  GetUserProfileConsentLoadingStatus: (state) => {
    return state.getUserProfileConsentLoadingStatus;
  },
  GetRegisterModel: (state) => {
    return state.registerModel;
  },
  GetUserprofileConsentModel: (state) => {
    return state.userprofileConsentModel;
  },
};
export { state, getters };
